import PropTypes from "prop-types";
import { memo } from "react";
import clsx from "clsx";

// Styles
import "./styles.css";

// MUI
import { Stack, Typography } from "@mui/material";

// Components
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";

const FunctionalInput = (props) => <InputFormExtension {...props} />;

const DoubleInputSeparator = (props) => {
	const { label, px, py, sx, classes } = props;
	const hasPlus = Boolean(label === "+");
	return (
		<Typography
			className={clsx({
				"small-label": true,
				"mini-plus": hasPlus,
				[classes]: classes,
			})}
			px={px}
			py={py}
			sx={{ ...sx, zIndex: 2 }}
		>
			{label}
		</Typography>
	);
};
DoubleInputSeparator.propTypes = {
	label: PropTypes.string,
	px: PropTypes.string,
	py: PropTypes.string,
	sx: PropTypes.object,
	classes: PropTypes.string,
};

const MemoInput = memo(FunctionalInput);
const MemoSeparator = memo(DoubleInputSeparator);

export default function DoubleInput(props) {
	const {
		firstInput = {
			data: [
				{
					type: "Unit",
					min: 0,
					max: 10000,
					decimals: 1,
					dashed: true,
					decimalsEditable: true,
					delta: 0.5,
				},
			],
			value: 0,
			defaultType: "Unit",
			error: false,
			disabled: false,
			readOnly: false,
			sx: null,
			onActionUpdate: () => {},
			onBlur: () => {},
			onChange: () => {},
			onChangeType: () => {},
			onClickText: () => {},
			onFocusOut: () => {},
		},
		secondInput = {
			data: [
				{
					type: "Unit",
					min: 0,
					max: 10000,
					decimals: 1,
					dashed: true,
					decimalsEditable: true,
					delta: 0.5,
				},
			],
			value: 0,
			defaultType: "Unit",
			error: false,
			disabled: false,
			readOnly: false,
			sx: null,
			onActionUpdate: () => {},
			onBlur: () => {},
			onChange: () => {},
			onChangeType: () => {},
			onClickText: () => {},
			onFocusOut: () => {},
		},
		separator = {
			label: "to",
			px: "5px",
			py: "0px",
			sx: null,
			classes: null,
		},
		componentProps = {
			sx: null,
		},
	} = props;

	return (
		<Stack direction="row" alignContent={"center"} alignItems={"center"} sx={componentProps.sx}>
			<MemoInput {...firstInput} />
			<MemoSeparator {...separator} />
			<MemoInput {...secondInput} />
		</Stack>
	);
}

DoubleInput.propTypes = {
	firstInput: PropTypes.shape({
		data: PropTypes.array,
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		defaultType: PropTypes.string,
		error: PropTypes.bool,
		disabled: PropTypes.bool,
		readOnly: PropTypes.bool,
		sx: PropTypes.object,
		onActionUpdate: PropTypes.func,
		onBlur: PropTypes.func,
		onChange: PropTypes.func,
		onChangeType: PropTypes.func,
		onClickText: PropTypes.func,
		onFocusOut: PropTypes.func,
	}),
	secondInput: PropTypes.shape({
		data: PropTypes.array,
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		defaultType: PropTypes.string,
		error: PropTypes.bool,
		disabled: PropTypes.bool,
		readOnly: PropTypes.bool,
		sx: PropTypes.object,
		onActionUpdate: PropTypes.func,
		onBlur: PropTypes.func,
		onChange: PropTypes.func,
		onChangeType: PropTypes.func,
		onClickText: PropTypes.func,
		onFocusOut: PropTypes.func,
	}),
	separator: PropTypes.shape({
		label: PropTypes.string,
		px: PropTypes.string,
		py: PropTypes.string,
		sx: PropTypes.object,
		classes: PropTypes.string,
	}),
	componentProps: PropTypes.shape({
		sx: PropTypes.object,
	}),
};
